<template>
  <div>

    <draggable :list="ghost" :item-key="(element, index) => index" class="list-group" :handle="'.drag-handle'" @end="handleSaveSection" @update="handleDragSection">
      <template #item="{ element, index }">
        <div class="list-group-item">
          <div class="create-form_form-section">
            <div :class="{
              'form mb-6 pb-6 border-b border-brand-light-gray': !dragEnabled,
              'bg-white border-brand-light-gray rounded-[8px] p-6 border': !dragEnabled && index === showSectionDetailIndex && status !== 'publish',
              '': dragEnabled,
            }">
              <div
                class="flex flex-col justify-between w-full gap-5 pb-3 mt-5 mb-6 border-b md:items-end md:flex-row border-brand-light-gray"
                v-if="index !== showSectionDetailIndex">
                <div class="mb-2 text-xl drag-handle cursor-grab">☰</div>
                <div class="mr-auto">
                    <p class="font-semibold text-brand-wicked paragraph-large">{{ element.name }}</p>
                    <p class="paragraph-small text-brand-medium-gray">{{ element.direction }}</p>
                </div>

                <div class="flex flex-col gap-4 md:items-center md:flex-row">
                  <button
                    class="flex items-center flex-none gap-2 font-semibold group paragraph-large paragraph-default text-brand-eggplant"
                    @click="expandSectionDetailsEdit(index)">
                    <span class="flex-none group-hover:underline group-hover:text-brand-indigo paragraph-default">Edit
                      Section
                      Details</span>
                    <svg class='flex-none group-hover:text-brand-indigo icon icon-edit size-4 text-brand-wicked'
                      aria-hidden='true'>
                      <use xlink:href='#icon-edit'></use>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="flex items-end justify-between w-full gap-5 pb-3 mt-5 mb-6 border-b border-brand-light-gray"
                v-else>
                <div>
                  <p class="mb-1 font-semibold text-brand-wicked paragraph-large">Edit Section Details</p>
                </div>
                <div class="">
                  <button
                    class="flex items-center gap-2 font-semibold group paragraph-large paragraph-default text-brand-eggplant"
                    @click="expandSectionDetailsEdit(index)">
                    <span
                      class="flex-none group-hover:underline group-hover:text-brand-indigo paragraph-default">Close</span>
                    <svg class='rotate-45 icon size-4 icon-plus' aria-hidden='true'><use xlink:href='#icon-plus'></use></svg>
                  </button>
                </div>
              </div>

              <section-detail-edit :section="element" :index="index" :error-message="errorMessage"
                @editSectionDetail="handleEditSectionDetail"
                v-if="showSectionDetailEdit && index === showSectionDetailIndex"></section-detail-edit>

              <div :class="{
                'pb-6 border-b border-brand-light-gray': dragEnabled,
                '': !dragEnabled,
              }">

                <concern-grid
                  :show-section-detail-index="showSectionDetailIndex"
                  :concerns="element.concerns"
                  :drag-enabled="dragEnabled"
                  :ogindex="index"></concern-grid>

                <template v-if="sections && sections.length > 0">

                  <button type="button" v-for="(concern, concernIndex) in sections.concerns" :key="concernIndex"
                    class="flex rounded-[8px] border border-brand-indigo group bg-white items-center gap-4 w-full p-3 hover:bg-brand-light-purple">
                    <div
                      class="icon-wrapper group-hover:bg-white rounded-full size-[18px] bg-brand-indigo flex items-center justify-center">
                      <svg class='icon size-[10px] group-hover:text-brand-indigo icon-plus text-white'
                        aria-hidden='true'>
                        <use xlink:href='#icon-plus'></use>
                      </svg>
                    </div>
                    <span class="font-semibold paragraph-small text-brand-eggplant">
                      {{ concern.name }}
                    </span>
                  </button>

                </template>

                <div class="flex items-center gap-3">
                  <input v-if="showSectionDetailEdit && index === showSectionDetailIndex" @click="submitSectionDetail"
                    :class="{ 'border border-form-error': errorMessage, '': !errorMessage }" id="save-section"
                    class="mt-4 w-fit-content form-submit btn-primary" type="submit" name="save_section" value="Save">

                  <input v-if="showSectionDetailEdit && index === showSectionDetailIndex" @click="removeSection(index)"
                    :class="{ 'border border-form-error': errorMessage, '': !errorMessage }" id="remove-section"
                    class="mt-4 w-fit-content form-submit btn-secondary" type="submit" name="remove_section"
                    value="Delete Section">
                </div>

              </div>
            </div>
          </div>
        </div>
      </template>
    </draggable>

    <div class="">
      <button id="create-form__add-section" class="flex items-center pl-3 pr-5 btn-primary group"
        @click.prevent="openAddSectionPopup" type="button">
        <svg class='mr-2 size-4 text-brand-white icon icon-plus' aria-hidden='true'>
          <use xlink:href='#icon-plus'></use>
        </svg>
        Add New Section
      </button>
    </div>
    
    <!-- Add new section popup -->
    <div v-if="showPopupAddNewSection" @click="closeAddNewSectionPopup"
      class="fixed -translate-x-1/2 -translate-y-1/2 z-[90] size-full bg-brand-scrim top-1/2 left-1/2"></div>
    <div v-if="showPopupAddNewSection"
      class="fixed w-[775px] max-w-[90vw] z-[91] rounded-[8px] md:py-12 md:px-16 p-6 mx-auto bg-white top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
      <button type="button" class="mfp-close size-10" @click="closeAddNewSectionPopup">
        <svg class="rotate-45 pointer-events-none size-6 icon icon-plus text-brand-medium-gray" aria-hidden="true">
          <use xlink:href="#icon-plus"></use>
        </svg>
      </button>
      <p class="mb-3 text-center hdg text-brand-wicked">
        Add New Section
      </p>
      <p class="mb-4 text-center text-brand-medium-gray paragraph-default">
        Add your section label and any directions you'd like to feature.
      </p>

      <div class="form">
        <label for="create-form-section-name">Section Name</label>
        <input v-model="sectionName" type="text" name="create-form-section-name" id="create-form-section-name" value="">
        <p class="field_description">e.g. "Face & Neck"</p>

        <label for="create-form-section-directions">Section Directions</label>
        <input v-model="sectionDirections" type="text" name="create-form-section-directions"
          id="create-form-section-directions" value="">
        <p class="field_description">e.g. "Select any concerns from this area. If you have none skip this section."
        </p>

        <input :class="{ 'border border-form-error': errorMessage, '': !errorMessage }" id="submit-new-section"
          class="w-full mt-4 form-submit btn-primary" type="submit" name="add_section" value="Continue"
          @click="addSection">

        <div v-if="errorMessage" class="mt-2 text-form-error">{{ errorMessage }}</div>
      </div>
    </div>

    <!-- edit section details popup -->
    <div v-if="showPopupAddSection" @click="closePopup"
      class="fixed -translate-x-1/2 -translate-y-1/2 z-[90] size-full bg-brand-scrim top-1/2 left-1/2"></div>
    <div v-if="showPopupAddSection"
      class="fixed w-[775px] max-w-[90vw] z-[91] rounded-[8px] md:py-12 md:px-16 p-6 mx-auto bg-white top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
      <button type="button" class="mfp-close size-10" @click="closePopup">
        <svg class="rotate-45 pointer-events-none size-6 icon icon-plus text-brand-medium-gray" aria-hidden="true">
          <use xlink:href="#icon-plus"></use>
        </svg>
      </button>

      <div class="mb-8 text-center hdg">
        Edit your section details!
      </div>

      <section-detail-edit :section="reactiveSections[editSelectionIndex]" :index="editSelectionIndex"
        :error-message="errorMessage" @editSectionDetail="handleEditSectionDetail"
        :showBorder="false"></section-detail-edit>

      <div class="flex items-center justify-end gap-3">
        <input @click="removeSection(editSelectionIndex)"
          :class="{ 'border border-form-error': errorMessage, '': !errorMessage }" id="remove-section"
          class="mt-4 w-fit-content form-submit btn-secondary" type="submit" name="remove_section"
          value="Delete Section" />
        <input @click="submitSectionDetail" :class="{ 'border border-form-error': errorMessage, '': !errorMessage }"
          id="save-section" class="mt-4 w-fit-content form-submit btn-primary" type="submit" name="save_section"
          value="Save" />

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue';
import axios from 'axios';
import draggable from "vuedraggable";
const props = defineProps({
  sections: Array,
  postId: Number,
  userId: Number,
  index: Number,
  status: String,
});

const emit = defineEmits(['updateLoading', 'updateSections']);


const editSelectionIndex = ref(0);
const showCreateConcernPopup = ref(false);
const reactiveSections = reactive([...props.sections]);
const ghost = reactive([...props.sections]);

// Watch for changes from parent and sync
watch(() => props.sections, (newSections) => {
  reactiveSections.splice(0, reactiveSections.length, ...newSections);
  ghost.splice(0, ghost.length, ...newSections);
}, { deep: true });
const dragEnabled = ref(true);
const errorMessage = ref('');
const showSectionDetailEdit = ref(false);
const showSectionDetailIndex = ref(-1);
const sectionDetailActive = ref('hidden');
const concernName = ref('');
const showPopup = ref(false);
const isSaving = ref(false);
const saveStatus = ref('');
const saveText = ref('Update');
const sectionName = ref('');
const sectionDirections = ref('');
const sectionOGIndex = ref(props.index);
const showPopupAddSection = ref(false);
const showPopupAddNewSection = ref(false);
const showPopupAddConcern = ref(false);

const openAddSectionPopup = () => {
  showPopupAddNewSection.value = true;
};

const closeAddNewSectionPopup = () => {
  showPopupAddNewSection.value = false;
  errorMessage.value = '';
  sectionName.value = '';
  sectionDirections.value = '';
};

const openEditSectionPopup = (idx) => {
  editSelectionIndex.value = idx;
  showPopupAddSection.value = true;
};

const closePopup = () => {
  showPopupAddSection.value = false;
  showPopupAddConcern.value = false;
};

const expandSectionDetailsEdit = (index) => {

  if (showSectionDetailIndex.value === index) {
    showSectionDetailEdit.value = !showSectionDetailEdit.value;
    if (!showSectionDetailEdit.value) {
      showSectionDetailIndex.value = -1; // Hide the index if the section is closed
    }
    dragEnabled.value = true;
  } else {
    showSectionDetailIndex.value = index;
    showSectionDetailEdit.value = true;
    dragEnabled.value = false;
  }
}

const addSection = async () => {
  errorMessage.value = '';
  if (sectionName.value.length <= 0 || sectionDirections.value.length <= 0) {
    errorMessage.value = 'Please provide some text.';
    return;
  } else {
    errorMessage.value = '';
  }

  const section = {
    name: sectionName.value,
    direction: sectionDirections.value,
    concerns: [],
  };

  reactiveSections.push(section);
  ghost.push(section);

  await handleSaveSection();

  sectionName.value = '';
  sectionDirections.value = '';
  showPopupAddNewSection.value = false;
}

const handleSaveSection = async () => {
  isSaving.value = true; // Set saving state to true
  saveStatus.value = ''; // Reset save status message
  emit('updateLoading', true);
  saveText.value = 'Saving...';

  try {
    const response = await axios({
      method: 'POST',
      url: `${siteInfo.wpApiSettings.ll}intakes/save-section`,
      headers: {
        'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: {
        userId: props.userId,
        postId: props.postId,
        sections: reactiveSections,
      }
    });

    // Check response status and set success message
    if (response.status === 200) {
      saveStatus.value = 'Sections saved successfully!';
      saveText.value = 'Saved';
      // Emit updated sections to parent
      emit('updateSections', [...reactiveSections]);
      setTimeout(() => {
        saveText.value = 'Update';
      }, 1500);
    }
  } catch (error) {
    console.error('Error updating user intro status:', error);
    saveText.value = 'Error, try again';
    saveStatus.value = 'Error saving sections. Please try again.';
    setTimeout(() => {
      saveText.value = 'Update';
    }, 2000);
  } finally {
    emit('updateLoading', false);
    isSaving.value = false; // Reset saving state
  }
};

const handleDragSection = (evt) => {
  reactiveSections.splice(0, reactiveSections.length, ...ghost);
};

const handleEditSectionDetail = async (section) => {
  reactiveSections[section.index].name = section.name;
  reactiveSections[section.index].direction = section.direction;
}

const submitSectionDetail = async (section) => {
  showSectionDetailIndex.value = null;
  showSectionDetailEdit.value = false;
  sectionDetailActive.value = 'hidden';
  await handleSaveSection();
  closePopup();
}

const addConcern = async (index) => {
  errorMessage.value = '';
  if (concernName.value.length <= 0) {
    errorMessage.value = 'Please provide some text.';
    return;
  }

  if (reactiveSections[index].concerns.includes(concernName.value)) {
    errorMessage.value = 'This concern already exists.';
    return;
  }

  reactiveSections[index].concerns.push(concernName.value);

  // await handleSaveSection();

  concernName.value = '';
}

const removeSection = async (index) => {
  if (reactiveSections.length > 1) {
    reactiveSections.splice(index, 1);    ghost.splice(index, 1);    showSectionDetailIndex.value = null;
    showSectionDetailEdit.value = false;
    sectionDetailActive.value = 'hidden';
    await handleSaveSection(); // Save after removing a section
    closePopup();
  } else {
    errorMessage.value = 'You must have at least one section.';
  }
}
</script>
